import Timeline from '@core/components/Timeline';
import { Grid, makeStyles } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { FaArrowCircleUp, FaCheckCircle, FaEdit, FaTimesCircle } from 'react-icons/fa';

export const styles = makeStyles({
  icone: {
    backgroundColor: '#919191',
  },
});

const tipoCampo = {
  DATA_VENCIMENTO: 'a data de vencimento',
  VALOR: 'o valor',
  VALOR_PAGO: 'o valor pago',
  DATA_RECEBIMENTO: 'a data de recebimento',
  DATA_LIQUIDACAO: 'a data de liquidação',
  FORMA_RECEBIMENTO: 'a forma de recebimento',
};

const origemBaixaLabel = {
  CONTA_RECEBER: 'manualmente',
  CONCILIACAO: 'pela conciliação bancária',
  ARQUIVO_RETORNO: 'pelo arquivo de retorno',
  PARTNER_BANK: 'automaticamente via Partner Bank',
  CONTRATO: 'pelo contrato',
  VENDA: 'pela venda',
  ADESAO: 'pela adesão',
};

const HistoricoContaReceberVisualizacao = ({ historico }) => {
  const classes = styles();

  const getSubtitulo = (registro) => {
    return moment(registro.dataHora).format('HH:mm [do dia] DD/MM/YYYY');
  };

  const getIcone = (registro) => {
    if (registro.nomeCampo === 'BAIXA') {
      return <FaCheckCircle size={20} />;
    }
    if (registro.nomeCampo === 'CANCELAMENTO_BAIXA') {
      return <FaTimesCircle size={20} />;
    }
    if (
      ['VALOR_PAGO', 'DATA_RECEBIMENTO', 'DATA_LIQUIDACAO', 'FORMA_RECEBIMENTO'].includes(registro.nomeCampo)
    ) {
      return <FaEdit size={20} />;
    }

    return <FaArrowCircleUp size={20} />;
  };

  const getDescricao = (registro) => {
    const usuario = registro.nomeUsuario || 'Usuário';
    const origemLabel = origemBaixaLabel[registro.origem] || 'manualmente';
    const isPartnerBank = registro.origem === 'PARTNER_BANK';

    if (registro.nomeCampo === 'BAIXA') {
      if (isPartnerBank) {
        return `Baixa realizada ${origemLabel}${
          registro.valorAtual ? ` no valor de R$ ${registro.valorAtual}` : ''
        }.`;
      }
      return `${usuario} realizou a baixa ${origemLabel}${
        registro.valorAtual ? ` no valor de R$ ${registro.valorAtual}` : ''
      }.`;
    }

    if (registro.nomeCampo === 'CANCELAMENTO_BAIXA') {
      if (isPartnerBank) {
        return `Baixa originada via Partner Bank foi cancelada${
          registro.valorAnterior ? ` no valor de R$ ${registro.valorAnterior}` : ''
        }.`;
      }
      return `${usuario} cancelou a baixa${
        registro.origem === 'CONCILIACAO' ? ' originada pela conciliação bancária' : ''
      }${registro.origem === 'ARQUIVO_RETORNO' ? ' originada pelo arquivo de retorno' : ''}${
        registro.valorAnterior ? ` no valor de R$ ${registro.valorAnterior}` : ''
      }.`;
    }

    if (
      tipoCampo[registro.nomeCampo] &&
      registro.nomeCampo !== 'DATA_VENCIMENTO' &&
      registro.nomeCampo !== 'VALOR'
    ) {
      if (isPartnerBank && registro.nomeCampo === 'DATA_LIQUIDACAO') {
        if (registro.valorAnterior && registro.valorAtual) {
          return `Data de liquidação atualizada automaticamente via Partner Bank de "${registro.valorAnterior}" para "${registro.valorAtual}".`;
        }
        return `Data de liquidação atualizada automaticamente via Partner Bank${
          registro.valorAtual ? ` para "${registro.valorAtual}"` : ''
        }.`;
      }
      return `${usuario} editou ${tipoCampo[registro.nomeCampo]} da baixa de "${registro.valorAnterior}" para "${
        registro.valorAtual
      }".`;
    }

    if (tipoCampo[registro.nomeCampo]) {
      return `${usuario} alterou ${tipoCampo[registro.nomeCampo]} de "${registro.valorAnterior}" para "${
        registro.valorAtual
      }" na edição da conta a receber.`;
    }

    return '';
  };

  return (
    <Grid container spacing={3}>
      <Timeline
        registros={historico}
        pageSize={3}
        getIcone={getIcone}
        getSubtitulo={getSubtitulo}
        getDescricao={getDescricao}
        iconeStyles={classes.icone}
      />
    </Grid>
  );
};

export default HistoricoContaReceberVisualizacao;
